import { useLocation, useNavigate } from "react-router-dom";

import logo from "../assets/logo.png";
import publicationsIcon from "../assets/publications.png";
import contactsIcon from "../assets/contacts.png";
import { Colors } from "../utils/colors";
import { Fonts } from "../utils/fonts";
import { TintIcon } from "./TintIcon";
import { FontSizes } from "../assets/fonts/fontSizes";

type TabKey = "documents" | "contacts";

function getActiveTab(pathname: string): TabKey {
  if (pathname.startsWith("/contacts")) return "contacts";
  return "documents";
}

export default function TopBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = getActiveTab(location.pathname);

  const go = (tab: TabKey) => {
    navigate(tab === "documents" ? "/documents" : "/contacts");
  };

  return (
    <div style={styles.header}>
      <img src={logo} alt="Logo" style={styles.logo} />

      <div style={styles.iconContainer}>
        <button
          type="button"
          onClick={() => go("documents")}
          style={
            activeTab === "documents" ? styles.activeButton : styles.button
          }
        >
          <TintIcon
            src={publicationsIcon}
            size={22}
            color={activeTab === "documents" ? Colors.Black : Colors.White}
          />
          <span
            style={activeTab === "documents" ? styles.activeText : styles.text}
          >
            Publications
          </span>
        </button>

        <div style={styles.separator} />

        <button
          type="button"
          onClick={() => go("contacts")}
          style={activeTab === "contacts" ? styles.activeButton : styles.button}
        >
          <TintIcon
            src={contactsIcon}
            color={activeTab === "contacts" ? Colors.Black : Colors.White}
          />
          <span
            style={activeTab === "contacts" ? styles.activeText : styles.text}
          >
            Contacts
          </span>
        </button>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 20,
    paddingBottom: 10,
    alignItems: "center",
  },
  logo: {
    height: 50,
    width: 102,
    objectFit: "contain",
  },
  iconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  activeButton: {
    height: 55,
    width: 80,
    borderRadius: 10,
    backgroundColor: Colors.SecondaryColor,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    cursor: "pointer",
  },
  button: {
    height: 55,
    width: 80,
    borderRadius: 10,
    backgroundColor: "rgba(255,255,255,0.10)", // #FFFFFF1A
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    cursor: "pointer",
  },
  separator: {
    width: 10,
  },
  activeText: {
    fontSize: FontSizes.xxs,
    fontWeight: Fonts.Medium,
    color: "#000000",
    paddingTop: 4,
    fontFamily: "Inter",
  },
  text: {
    fontSize: FontSizes.xxs,
    fontWeight: Fonts.Medium,
    color: "#FFFFFF",
    paddingTop: 4,
    fontFamily: "Inter",
  },
};
